export type PartyTypeProps = {
  value: string;
  label: string;
  badgeClass: string;
};

export const partyTypes: PartyTypeProps[] = [
  {
    value: "materials",
    label: "મટીરીયલ",
    badgeClass: "bg-blue-100 text-blue-800 hover:bg-primary/80",
  },
  {
    value: "cutting",
    label: "કટીંગ",
    badgeClass: "bg-green-100 text-green-800 hover:bg-primary/80",
  },
  {
    value: "turning",
    label: "ટર્નિંગ",
    badgeClass: "bg-orange-100 text-orange-800 hover:bg-primary/80",
  },
  {
    value: "vmc",
    label: "VMC",
    badgeClass: "bg-purple-100 text-purple-800 hover:bg-primary/80",
  },
];

export const partyTypeLabel = (type: string) =>
  partyTypes.find((partyType) => partyType.value === type)?.label || type;

export const partyTypeBadgeClass = (type: string) =>
  partyTypes.find((partyType) => partyType.value === type)?.badgeClass ||
  "bg-gray-100 text-gray-800 hover:bg-primary/80";
